import { EQuestionType, EQuizMode } from '@constants';
import { ICreateQuestion, IGeneratedQuestion } from '@sdk/contracts';
import { TFunction } from 'i18next';

import { ManagerQuizzesTranslations } from '@/pages/Manager';

export const mapGeneratedQuestionsData = (
  questions: IGeneratedQuestion[],
  mode: EQuizMode,
  t: TFunction<'ManagerQuizzesTranslations'>
): ICreateQuestion[] => {
  const isTrueFalse = mode === EQuizMode.TRUE_FALSE;
  return questions.map(question => ({
    title: question.title,
    answers: question.answers.map(answer => ({
      text: isTrueFalse ? t(answer as keyof typeof ManagerQuizzesTranslations) : answer
    })),
    correctAnswer: question.correctAnswer,
    type: EQuestionType.AI
  }));
};
